/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Styles
import { Row } from "components/styles";
import { useEffect, useState } from "react";
import { StyledFooter } from "./styles";
//#endregion

const STYLE_PROPS = {
    FOOTER_BUTTON: {
        size: "medium",
        width: "130px"
    }
};

const FooterButtons = ({
    actions: {
        doDelete,
        doCancel, 
        doSave
    },
    canDelete,
    form, getDisabledSaveButton,
    showDialogNotUpdateForFutureReservationsWhenChangesCapacity
}) => {
    //#region States
    const [disabledSaveButton, setDisabledSaveButton] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        setDisabledSaveButton(getDisabledSaveButton());
    }, [form.value, showDialogNotUpdateForFutureReservationsWhenChangesCapacity]);
    //#endregion
    return (
        <StyledFooter justify={canDelete ? "space-between" : "flex-end"}>
            {canDelete &&
            <CustomButton 
                variant="terciary" 
                text="Eliminar"
                onClick={doDelete}/>}
            <Row>
                <CustomButton 
                    variant="secondary"
                    {...STYLE_PROPS.FOOTER_BUTTON}
                    text="Cancelar"
                    onClick={doCancel}/>
                <CustomButton 
                    {...STYLE_PROPS.FOOTER_BUTTON}
                    text="Guardar"
                    onClick={doSave}
                    disabled={disabledSaveButton}/>
            </Row>
        </StyledFooter>
    );
}

export default FooterButtons;